import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "src/app/shared/loader/loader.module";
import { SharedModule } from "src/app/shared/shared.module";
import { DevicesRoutingModule } from "./devices-routing.module";
import { DevicesComponent } from "./devices.component";
import { AddDeviceFacilityComponent } from './add-device-facility/add-device-facility.component';

@NgModule({
  declarations: [
    DevicesComponent,
    AddDeviceFacilityComponent
  ],
  imports: [
    CommonModule,
    DevicesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    LoaderModule,
    SharedModule
  ]
})
export class DevicesModule { }